import React, {useState} from 'react';
import {Modal, ModalContent, ModalBody, ModalHeader} from '@/components/modal';

interface DeleteConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void; // Triggered when the user confirms the delete action
    matchName: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
                                                                             open,
                                                                             onClose,
                                                                             onConfirm,
                                                                             matchName,
                                                                         }) => {
    const [inputValue, setInputValue] = useState<string>('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const isConfirmButtonEnabled = inputValue === matchName;

    return (
        <Modal open={open} onClose={onClose} className="!flex items-center justify-center">
            <ModalContent className="max-w-md w-full p-6">
                <ModalHeader className="p-0 border-0">
                    <div className="flex items-center justify-between flex-wrap grow gap-5 pb-5">
                        <h1 className="text-lg font-semibold leading-none text-gray-900">
                            Delete Match
                        </h1>
                        <button className="btn btn-sm btn-light" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </ModalHeader>
                <ModalBody className="scrollable-y py-0 mb-5 ps-0 pe-3 -me-5.5">
                    <p className="text-sm text-gray-700 pb-3">
                        Are you sure you want to delete the match{' '}
                        <span className="font-semibold text-gray-900">{matchName}</span>? This action
                        cannot be undone. Please type the match name below to confirm.
                    </p>
                    <input
                        type="text"
                        value={inputValue}
                        onChange={handleInputChange}
                        placeholder="Type match name to confirm"
                        className="border border-gray-400 p-3 rounded-md text-sm w-full focus:outline-none"
                    />
                    <div className="flex justify-end gap-2 mt-4">
                        <button className="btn btn-sm btn-light" onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            className="btn btn-sm btn-danger"
                            onClick={onConfirm}
                            disabled={!isConfirmButtonEnabled}
                        >
                            Confirm
                        </button>
                    </div>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export {DeleteConfirmationModal};
